import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { environment } from 'src/environments/environment';
import { NewsService } from '../../all-news/news.service';
import { ProfileService } from '../../profile/profile.service';
import { NewsUpdateService } from '../news-update.service';
import { ModalPreviewComponent } from './modal-preview.component';
import { LearningCenterService } from '../../learning-center/learning-center.service';

@Component({
  selector: 'app-manage-news',
  templateUrl: './manage-news.component.html',
  styleUrls: ['./manage-news.component.scss']
})
export class ManageNewsComponent implements OnInit {
  newsHeader: string;
  newsForm: FormGroup;
  newsFormEdit: FormGroup;
  dialogConfig = new MatDialogConfig();
  newsData = null;
  dateTime = [];
  coverName: string = null;
  coverUrl: string = null;
  category;
  profile;
  isLoading: boolean = false;
  isEdit: boolean;
  newsId: string;

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '500px',
    maxHeight: 'auto',
    width: '100%',
    minWidth: '100%',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
      { class: 'th-sarabun', name: 'Sarabun' },
      { class: 'K2D', name: 'K2D' },
    ],
    uploadUrl: environment.URL + '/manage_admin/uploadImgaeContentNews',
    uploadWithCredentials: false,
    sanitize: false,
    toolbarPosition: 'top'
  };

  allLearningCenter: any[] = [];
  learningCenter: any;

  constructor(
    public matDialog: MatDialog,
    private fb: FormBuilder,
    private newsUpdateService: NewsUpdateService,
    private newsService: NewsService,
    private profileService: ProfileService,
    private gobalFunctionService: GobalFunctionService,
    private learningCenterService: LearningCenterService,
  ) {

  }

  ngOnInit(): void {
    this.newsForm = this.fb.group({
      newsTital: ['', Validators.required],
      newsCover: ['', Validators.required],
      newsCategory: ['', Validators.required],
      newsDate: [''],
      newsAlwaysOpen: [''],
      newsContent: ['', Validators.required],
      centerId: [''],
    })

    this.newsFormEdit = this.fb.group({
      newsTital: ['', Validators.required],
      newsCover: [''],
      newsCategory: ['', Validators.required],
      newsDate: [''],
      newsAlwaysOpen: [''],
      newsContent: ['', Validators.required],
      centerId: [''],
    })

    this.isEdit = JSON.parse(new URL(location.href).searchParams.get('isEdit'));
    this.newsId = new URL(location.href).searchParams.get('news_id');
    this.profileService.getProfile().subscribe(profile => this.profile = profile.result);
    if (this.isEdit) {
      this.gobalFunctionService.setTitle('แก้ไขข่าวสาร');
    } else {
      this.gobalFunctionService.setTitle('สร้างข่าวสาร');
    }


    if ((this.isEdit && this.newsId) || (!this.isEdit && this.newsId)) {
      this.newsService.getNews(this.newsId).pipe(
        tap(res => {
          this.newsData = res.result.DETAIL_NEWS[0];
          console.log(this.newsData);

          if (this.newsData.ALWAYS_OPEN == 'true') {
            this.newsFormEdit['newsAlwaysOpen'] = true;
            this.newsData.ALWAYS_OPEN = true;
            this.dateTime = null;
          } else {
            this.newsFormEdit['newsAlwaysOpen'] = false;
            this.newsData.ALWAYS_OPEN = false;
            this.dateTime[0] = new Date(this.newsData.NEWS_START);
            this.dateTime[1] = new Date(this.newsData.NEWS_END);
          }

          if (this.newsData.NEWS_PICNAME !== '') {
            this.coverName = this.newsData.NEWS_PICNAME;
            this.coverUrl = this.newsData.NEWS_PIC
          }
        })
      ).subscribe()
    } else {
      this.newsForm['newsAlwaysOpen'] = false;
    }

    const _categorySub = this.newsUpdateService.getCategoryNews().subscribe(category => {
      this.category = category.result;
    }, err => {
    }, () => { _categorySub.unsubscribe() })

    this.getAllLearning();
  }

  preview(newsForm, isEdit) {
    if (!newsForm.newsDate && !newsForm.newsAlwaysOpen) {
      alert('กรุณาใส่ เวลาเปิด / ปิดข่าว')
    } else {
      if (!newsForm.newsCover && this.coverName) {
        this.newsHeader = this.coverUrl;
        newsForm['newsCover'] = this.coverUrl;
      }

      if (newsForm.newsAlwaysOpen) {
        newsForm['newsAlwaysOpen'] = 'true'
      } else {
        newsForm['newsAlwaysOpen'] = 'false'
      }

      this.dialogConfig.disableClose = true;
      this.dialogConfig.id = 'modalAddNews';
      this.dialogConfig.width = '60%'
      this.dialogConfig.data = {
        title: 'Preview : ' + newsForm.newsTital,
        isEdit: isEdit,
        actionBtnText: 'บันทึกและเผยแพร่',
        cancleBtnText: 'ย้อนกลับ',
        customStyle: 'min-width: 650px;',
        newsForm: newsForm,
        newsHeader: this.newsHeader,
        profile: this.profile,
        newsId: this.newsId
      }

      const formDialog = this.matDialog.open(ModalPreviewComponent, this.dialogConfig);
      formDialog.afterClosed().subscribe()
    }
  }

  onFileSelected(e, newsForm) {
    const fileType = this.gobalFunctionService.getTypeFile(e.target.files[0]);

    if (fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg') {
      if (e.target.files && e.target.files[0]) {
        this.coverName = e.target.files[0].name;

        const file = (e.target as HTMLInputElement).files[0];
        newsForm.patchValue({
          newsCover: file
        });
        newsForm.get('newsCover').updateValueAndValidity()

        const reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (event) => {
          var file = new File([reader.result], <any>reader.result);
          this.newsHeader = file.name;
        }
      }
    } else {
      alert('การอัปโหลดรูปภาพรองรับแค่ไฟล์ JPG, JPEG, PNG เท่านั้น กรุณาลองใหม่อีกครั้ง');
    }
  }

  delete(newsId) {
    this.dialogConfig.disableClose = true;
    this.dialogConfig.id = 'modalDeleteNews';
    this.dialogConfig.autoFocus = false;
    this.dialogConfig.data = {
      title: 'คุณต้องการลบข่าว?',
      description: 'คุณต้องการลบข่าวนี้? เมื่อลบแล้วผู้ใช้งานจะไม่สามารถเห็นข่าวนี้ได้',
      actionBtnText: 'ลบ',
      cancleBtnText: 'ย้อนกลับ',
      isDelete: true
    }

    const formDialog = this.matDialog.open(ModalComponent, this.dialogConfig);
    formDialog.afterClosed().pipe(
      switchMap(res => {
        if (res) {
          const body = {
            NEWS_ID: newsId
          }
          return this.newsUpdateService.deleteNews(body).pipe(
            switchMap(res => {
              const dialogConfig = new MatDialogConfig();
              dialogConfig.disableClose = true;
              dialogConfig.id = 'modalConfirm';
              dialogConfig.width = '350px';
              dialogConfig.data = {
                title: 'สำเร็จ',
                description: '<img src="../../../assets/check.png" width="100px;" class="img-center">ลบข่าวสำเร็จแล้ว',
                cancleBtnText: 'ยืนยัน',
              }
              const modal = this.matDialog.open(ModalComponent, dialogConfig);
              return modal.afterClosed();
            }),
            tap(res => {
              if (!res) {
                window.opener.location.reload();
                setTimeout(() => {
                  window.close()
                }, 10);
              }
            })
          )
        }
        return of(false)
      })
    ).subscribe()
  }

  clearValueNewsDate(newsForm) {
    if (!newsForm['newsAlwaysOpen'].value) {
      newsForm.controls['newsDate'].setValue(null);
    }
  }

  getAllLearning() {
    this.learningCenterService.getAllLearningCenterAdmin().subscribe(
      res => {
        res.result.forEach(e => {
          this.allLearningCenter.push({
            CENTER_NAME: e.CENTER_NAME,
            CENTER_ID: e.CENTER_ID,
          })
        })
      });
  }

  patchLearning(val, form) {
    let value = [];
    value = val.value;
    // console.log(val.value);
    form.patchValue({
      centerId: value
    });
    form.get('centerId').updateValueAndValidity();
    // console.log(form.value.centerId);
  }

  compareFn(i1: any, i2: any): boolean {
    return i1 && i2 ? i1.CENTER_ID === i2.CENTER_ID : i1 === i2;
  }
}
